/**
 * Processa HTML para:
 * 1. Converter URLs em texto puro para links clicáveis
 * 2. Encurtar o texto visível de URLs longas
 * Mantém o href original intacto
 * @param {string} html - HTML que pode conter URLs
 * @param {number} maxLength - Tamanho máximo do texto do link (padrão: 50)
 * @returns {string} HTML com links clicáveis e encurtados
 */
export function shortenLinks(html, maxLength = 20) {
  if (!html) return '';
  
  // Função auxiliar para encurtar URL
  const shorten = (url) => {
    if (url.length > maxLength) {
      return url.substring(0, maxLength) + '...';
    }
    return url;
  };
  
  // Primeiro, encurtar URLs que já estão em tags <a>
  let result = html.replace(/<a\s+([^>]*href="[^"]*"[^>]*)>([^<]*)<\/a>/gi, (match, attributes, linkText) => {
    if (linkText.length > maxLength && /^https?:\/\//i.test(linkText)) {
      return `<a ${attributes}>${shorten(linkText)}</a>`;
    }
    return match;
  });
  
  // Depois, converter URLs em texto puro (que não estão dentro de tags <a>)
  // Usa um regex que encontra URLs não precedidas por href=" ou >
  const urlRegex = /(https?:\/\/[^\s<>"]+)/gi;
  
  // Dividir o HTML em partes: dentro de tags <a> e fora
  const parts = result.split(/(<a\s[^>]*>.*?<\/a>)/gi);
  
  result = parts.map(part => {
    // Se a parte é uma tag <a>, não processar
    if (/<a\s/i.test(part)) {
      return part;
    }
    // Converter URLs em texto puro para links
    return part.replace(urlRegex, (url) => {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${shorten(url)}</a>`;
    });
  }).join('');
  
  return result;
}
